import FullWidthHeader from '../FullWidthHeader';

const ConfirmAppointmentPageHeader = () => {
  return <FullWidthHeader>Confirm your new appointment</FullWidthHeader>;
};

export default ConfirmAppointmentPageHeader;
